import React from 'react';
import LabelWithSymbols from '@common/component/atoms/LabelBySymbols';
import Content from '../../molecules/Content';
export interface OptinMailContentProps {
  title: string;
  detail: string;
  senderInfo: string;
  notAccept: () => void;
  accept: () => void;
}

/**
 * メール受信の承諾画面コンテンツ部
 */
const OptinMailContent: React.FC<OptinMailContentProps> = ({ title, detail, senderInfo, accept, notAccept }) => {
  return (
    <div className='mo-container'>
      <Content title={title} detail={detail} titleClassName='mo-title' detailClassName='mo-text' />
      <div>
        <button className='mo-button--accept' data-testid='opt-in-mail-content--accept-button' onClick={accept}>
          承諾する
        </button>
        <button className='mo-button--not-accept' data-testid='opt-in-mail-content--not-accept-button' onClick={notAccept}>
          承諾しない
        </button>
        <LabelWithSymbols text={senderInfo} className='mo-text--info' data-testid='opt-in-mail-content--sender-info-text' />
      </div>
    </div>
  );
};
export default OptinMailContent;
